import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { isNative } from '../lib/platform';

export function useNativeNotificationRouting() {
  const navigate = useNavigate();
  const listenerRef = useRef(null);

  useEffect(() => {
    if (!isNative()) return;

    let cancelled = false;

    (async () => {
      try {
        const { PushNotifications } = await import('@capacitor/push-notifications');

        if (cancelled) return;

        listenerRef.current = PushNotifications.addListener(
          'pushNotificationActionPerformed',
          (notification) => {
            const url = notification.notification?.data?.url;
            if (url && typeof url === 'string') {
              navigate(url);
            }
          }
        );
      } catch { /* plugin not available */ }
    })();

    return () => {
      cancelled = true;
      if (listenerRef.current) {
        listenerRef.current.then((l) => l.remove()).catch(() => {});
        listenerRef.current = null;
      }
    };
  }, [navigate]);
}
